module.exports = __webpack_public_path__ + "img/frown-icon.2614d1d6.svg";